import Vue from 'vue'
import router from '@/router'
import store from '@/store/'
import { ACCESS_TOKEN,USER_INFO, USER_ROLE } from "@/store/mutation-types";
import HomeLayout from './layouts/HomeLayout'
import CmsLayout from './layouts/CmsLayout'
import UserLayout from './layouts/UserLayout'
import BlankLayout from '@/components/layouts/BlankLayout'
import { getAction } from "@/api/manage";

const whiteList = ['/login', '/home', '/cms', '/cert/query'] // no redirect whitelist
//改变地址栏参数
const changeURLStatic = function(name, value) {
  var url = location.href;
  var reg = eval('/([\?|&]'+name+'=)[^&]*/gi');
  value = value.toString().replace(/(^\s*)|(\s*$)/g,"");
  if(!value){
      var url2 = url.replace(reg , '');
  }else{
      if(url.match(reg)){
          var url2 = url.replace(reg , '$1' + value);
      }else{
          var url2 = url + (url.indexOf('?') > -1 ? '&' : '?') + name + '=' +value;
      }
  }
  history.replaceState(null,null, url2);
}

router.beforeEach((to, from, next) => {
  console.log(to);
  if(to.query.token){ //科创筑梦token登录
    getAction("/thirdLogin/cyscc/getUserInfo?token=" + to.query.token).then(tokenRes=>{
      if(tokenRes.success){
        getAction("/thirdLogin/getLoginUser/" + tokenRes.result).then(res=>{
          if(res.success){
            let token = res.result.token
            let userInfo = res.result.userInfo
            const expire = 7 * 24 * 60 * 60 * 1000
            Vue.ls.set("cysccToken", to.query.token, expire)
            Vue.ls.set(ACCESS_TOKEN, token, expire)
            store.commit('SET_TOKEN', token)
            Vue.ls.set(USER_INFO, userInfo, expire)
            store.commit('SET_USER_INFO', userInfo)
            store.commit('SET_NAME', { username: userInfo.username, realname: userInfo.realname })
            store.commit('SET_AVATAR', userInfo.avatar)
            changeURLStatic("token", "")
            next()
          }else{
            alert("登录失败")
          }
        })
      }else{
        alert("登录失败")
      }
    })
  }
  if (Vue.ls.get(ACCESS_TOKEN)) {
      next()
  } else {
    if (whiteList.indexOf(to.path) == -1) {
      next()
      // next({ path: '/user/login', query: { redirect: to.fullPath } })
    }else{
      next()
    }
  }
})
let tenantConfig = store.getters.tenantInfo
/**
 * 基础路由
 * @type { *[] }
 */
const RouterMap = [
  
  {
    path: '/',
    component: BlankLayout,
    redirect: tenantConfig && tenantConfig.home || '/index',
    hidden: true,
    children: [
      {
        path: '/index',
        name: 'home',
        component: () => import(/* webpackChunkName: "kexie" */ './views/Home')
      },
      {
        path: '/courseHome',
        name: 'courseHome',
        component: () => import(/* webpackChunkName: "kexie" */ './views/CourseHome')
      },
    ]
  },
  {
    path: '/',
    component: CmsLayout,
    redirect: '/index',
    hidden: true,
    children: [
      {
        path: '/login',
        name: 'login',
        component:() => import(/* webpackChunkName: "kexie" */ './views/user/Login')
      },
      {
        path: '/register',
        name: 'register',
        component:() => import(/* webpackChunkName: "kexie" */ './views/user/Register')
      },
      {
        path: '/find',
        name: 'find',
        component:()=>import(/* webpackChunkName: "xinai" */ './views/user/Find')
      }
    ]
  },
  {
    path: '/examine',
    component:()=>import(/* webpackChunkName: "kexie" */ '@/components/exam/Examine')
  },
  {
    path: '/user',
    component: UserLayout,
    redirect: '/user/event',
    children: [
      {
        path: 'event',
        name: 'userEvent',
        component: () => import(/* webpackChunkName: "kexie" */ './views/user/Event')
      },
      {
        path: 'order',
        name: 'userOrder',
        component: () => import(/* webpackChunkName: "kexie" */ './views/user/Order')
      },
      {
        path: 'info',
        name: 'userInfo',
        component: () => import(/* webpackChunkName: "kexie" */ './views/user/Info')
      },
      {
        path: 'cert',
        name: 'userCert',
        component: () => import(/* webpackChunkName: "kexie" */ './views/user/Cert')
      },
      {
        path: 'score',
        name: 'userScore',
        component: () => import(/* webpackChunkName: "kexie" */ './views/user/Score')
      },
      {
        path: 'setting',
        name: 'userSetting',
        component: () => import(/* webpackChunkName: "kexie" */ './views/user/Setting')
      },
      {
        path: 'work',
        name: 'userWork',
        component: () => import(/* webpackChunkName: "kexie" */ './views/user/Work')
      },
      {
        path: 'question',
        name: 'userQuestion',
        component: () => import(/* webpackChunkName: "kexie" */ './views/user/Question')
      },
    ]
  },
  {
    path: '/event',
    name: 'event',
    redirect: '/event/cate',
    component: CmsLayout,
    children:[
      {
        path: 'cate',
        name: 'eventCategory',
        component: () => import(/* webpackChunkName: "kexie" */ './views/EventCategory')
      },
      {
        path: 'list',
        name: 'eventList',
        component: () => import(/* webpackChunkName: "kexie" */ './views/EventList')
      },
      {
        path: 'detail',
        name: 'eventDetail',
        component: () => import(/* webpackChunkName: "kexie" */ './views/EventDetail')
      },
      {
        path: 'apply',
        name: 'eventApply',
        component: () => import(/* webpackChunkName: "kexie" */ './views/EventApply')
      },
      {
        path: 'desc',
        name: 'eventDesc',
        component: () => import(/* webpackChunkName: "kexie" */ './views/EventDesc')
      },
      {
        path: 'trends',
        name: 'eventTrends',
        component: () => import(/* webpackChunkName: "kexie" */ './views/EventTrends')
      },
      {
        path: 'old',
        name: 'eventOld',
        component: () => import(/* webpackChunkName: "kexie" */ './views/EventOld')
      },
      {
        path: 'workList',
        name: 'workList',
        component: () => import(/* webpackChunkName: "kexie" */ './views/WorkList')
      },
      {
        path: 'workDetail',
        name: 'workDetail',
        component: () => import(/* webpackChunkName: "kexie" */ './views/WorkDetail')
      },
      {
        path: '/cert/query',
        name: 'certQuery',
        component: () => import(/* webpackChunkName: "kexie" */ './views/CertQuery')
      },
    ]
  },
  {
    path: '/course',
    name: 'course',
    redirect: '/course/list',
    component: CmsLayout,
    children: [
      {
        path: 'list',
        name: 'courseList',
        component: () => import(/* webpackChunkName: "kexie" */ './views/CourseList')
      },
      {
        path:'detail',
        name:'courseDetail',
        component: () => import(/* webpackChunkName: "kexie" */ './views/CourseUnitDetail')
      }
    ]
  },
  {
    path: '/cms',
    name: 'cms',
    redirect: '/cms/list',
    component: CmsLayout,
    children: [
      {
        path: 'list',
        name: 'cmsList',
        component: () => import(/* webpackChunkName: "kexie" */ './views/CmsList')
      },
      {
        path: 'preview',
        name: 'cmsPreview',
        component: ()=> import(/* webpackChunkName: "kexie" */ './views/CmsPreviewList')
      },
      {
        path: 'detail',
        name: 'cmsDetail',
        component: () => import(/* webpackChunkName: "kexie" */ './views/CmsDetail')
      },
      {
        path: 'video',
        name: 'cmsVideo',
        component: () => import(/* webpackChunkName: "kexie" */'./views/VideoList')
      },
      {
        path: 'pic',
        name: 'cmsPic',
        component: () => import(/* webpackChunkName: "kexie" */'./views/PicList')
      },
      {
        path: 'live',
        name: 'cmsLive',
        component: () => import(/* webpackChunkName: "kexie" */'./views/LiveList')
      },
      {
        path: 'people',
        name: 'cmsPeople',
        component: () => import(/* webpackChunkName: "kexie" */'./views/PeopleList')
      }
    ]
  },

]
export default RouterMap